// src/content/default.ts

import { Content } from "../common/types/types";

export const content: Content = {
  about: {
    title: "О нас",
    metaDescription: "",
    heroImage: "",
    intro: "",
    sections: [],
  },
};
